import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: ${props => props.theme.spacing.sp4};

  .MuiFormHelperText-root {
    display: none;
  }
`

export const Hint = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp8};
  padding: 0 ${props => props.theme.spacing.sp16};
`
